export const EXSBPRICEITEM_DELETE_RESET = 'EXSBPRICEITEM_DELETE_RESET'
export const EXSBPRICEITEM_DELETE_SET_ERROR = 'EXSBPRICEITEM_DELETE_SET_ERROR'
export const EXSBPRICEITEM_DELETE_SET_DELETED = 'EXSBPRICEITEM_DELETE_SET_DELETED'
export const EXSBPRICEITEM_DELETE_TOGGLE_LOADING = 'EXSBPRICEITEM_DELETE_TOGGLE_LOADING'
